import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { rememberSupportReturn } from '../lib/supportHandoffReturn';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SupportHandoffPage() {
  const { token } = useParams();
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  useEffect(() => {
    if (loading) return;
    if (!user) {
      rememberSupportReturn(location.pathname);
      navigate(`/login?next=${encodeURIComponent(location.pathname)}`, { replace: true });
      return;
    }
    let active = true;
    fetch(`${API}/api/support-chat/admin/handoff-link/${encodeURIComponent(token)}`, { credentials: 'include' })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || 'This conversation could not be opened.');
        if (active) navigate(`/company-manager-dashboard?dept=customer-service&cs_tab=support-chat&chat_session=${encodeURIComponent(data.session_id)}&claim=1`, { replace: true });
      }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [loading, user?.user_id, token, location.pathname, navigate]);
  return <main className="min-h-screen bg-zinc-950 p-6 text-white flex items-center justify-center" data-testid="support-handoff-page">
    <div className="max-w-md space-y-4 text-center">
      <h1 className="text-2xl font-bold" data-testid="support-handoff-heading">Customer Service</h1>
      {error ? <>
        <p role="alert" className="text-red-300" data-testid="support-handoff-error">{error}</p>
        <Link to="/company-manager-dashboard?dept=customer-service&cs_tab=support-chat" className="text-[#C9A962] underline" data-testid="support-handoff-dashboard-link">Open Customer Service</Link>
      </> : <p role="status" className="text-zinc-300" data-testid="support-handoff-loading">Opening your support conversation…</p>}
    </div>
  </main>;
}